import { useTranslation } from 'react-i18next';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';
import { Modal } from 'components/Modal';

import * as S from './InfoModal.styles';

type NewListModalProps = {
  onClose: () => void;
  title: string;
  info: string;
  actionText: string;
  onAction: () => void;
  isLoading?: boolean;
};

export function InfoModal(props: NewListModalProps): React.ReactElement {
  const { title, info, onClose, actionText, onAction, isLoading } = props;
  const { t } = useTranslation();

  return (
    <Modal onClose={onClose}>
      <S.Container>
        <S.Title scale="xl3" color="grayDark" textTransform="isFirstLetterUppercase">
          {title}
        </S.Title>

        <S.Wrapper>
          <Headline fontFamily="LFT Zeno" fontWeight="extraLight" scale="s">
            {info}
          </Headline>
        </S.Wrapper>

        <S.ButtonWrapper>
          <Button
            onClick={onClose}
            motive="cancelTertiary"
            fontFamily="LFT Zeno"
            textTransform="isFirstLetterUppercase"
          >
            {t('common.cancel')}
          </Button>

          <Button
            textTransform="isFirstLetterUppercase"
            fontWeight="light"
            fontFamily="LFT Zeno"
            motive="actionTertiary"
            onClick={onAction}
            isLoading={isLoading}
          >
            {actionText}
          </Button>
        </S.ButtonWrapper>
      </S.Container>
    </Modal>
  );
}
